// Import model
import { FilterSectionLineRequest } from '../models/FilterSectionLineRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { SectionLineCondition } from '../models/SectionLineCondition';
import { SectionLineFields } from '../models/SectionLineFields';
import { SectionLineIndexedFields } from '../models/SectionLineIndexedFields';

// Import dependency serializers (for complex types)
import { SectionLineConditionSerializer } from './SectionLineConditionSerializer';
import { SectionLineFieldsSerializer } from './SectionLineFieldsSerializer';
import { SectionLineIndexedFieldsSerializer } from './SectionLineIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterSectionLineRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterSectionLineRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterSectionLineRequest instance
   */
  static deserialize(json: string): FilterSectionLineRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterSectionLineRequest instance
   */
  static fromObject(obj: any): FilterSectionLineRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterSectionLineRequest');
    }


    const instance: FilterSectionLineRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as SectionLineIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as SectionLineFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        SectionLineConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterSectionLineRequest instances
   */
  static deserializeArray(json: string): FilterSectionLineRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterSectionLineRequest instance to a JSON string
   */
  static serialize(instance: FilterSectionLineRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterSectionLineRequest instance to a plain object
   */
  static toObject(instance: FilterSectionLineRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        SectionLineConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterSectionLineRequest instances to a JSON string
   */
  static serializeArray(instances: FilterSectionLineRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
